<template>
  <!-- 标题 高级筛选 -->
  <div class="bg-shadow flex-wrap el-tabs__content">

    <!-- 重要指标 -->
    <index-common v-if="page.isIndex"
                  v-loading="loading.indexLoading"
                  element-loading-background="#FFF"
                  element-loading-spinner="el-icon-loading"
                  element-loading-customClass="defineLoading"
                  element-loading-text="拼命的加载中"
                  class="block-preview noCompare_min"
                  :options="summaryList">
    </index-common>
    <!-- 趋势图 -->
    <chart-content :flod="flod"
                   v-if="page.isChart">
      <div class="flex-between gragh-index">
        <!-- 图的指标 -->
        <component :is="page.selectChart"
                   :class-key="page.chartKey"
                   :number="page.chartNum"
                   :indicator="page.indicator"
                   :address="page.chartAddress">
        </component>
        <!-- 按日等标签 -->
        <div v-if="page.isTime">
          <el-radio-group v-model="tabPosition">
            <el-radio-button label="byDay"
                             v-if="page.isDay">按日</el-radio-button>
            <el-radio-button :disabled=disabled[0]
                             label="byWeek">按周</el-radio-button>
            <el-radio-button :disabled=disabled[1]
                             label="byMonth">按月</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <component :is="page.selectTable"
                 :class-key="page.tableKey"
                 :number="page.tableNum"
                 :address="page.tableAddress">
      </component>
      <div class="table_min"
           v-if="page.isTableKey"
           v-loading="loading.tableLoading"
           element-loading-background="#FFF"
           element-loading-spinner="el-icon-loading"
           element-loading-customClass="defineLoading"
           element-loading-text="拼命的加载中">
        <component :title="page.tableTitle"
                   :is="page.normalTable"
                   :tableInfo="tableInfo"
                   :devsort-style="tableInfo.devsort"
                   :focus="page.focus"
                   :queryKey="queryKey">
        </component>
      </div>
    </chart-content>
  </div>

</template>

<script>
import * as queryUtil from "../../../common/query";
import * as util from "../../../common/util";
import * as Func from "../../../common/commonFun";
import { content } from "./component";
export default {
  components: {
    ...content
  },
  props: {
    page: [Object],
    headerVal: [Object],
    header: [Object],
    queryKey: [String],
    headerShow: [Array]
  },
  data() {
    return {
      loading: {
        indexLoading: false,
        tableLoading: false
      },
      // 表格
      tableInfo: {},
      // 指标
      summaryList: [],
      // 按周
      tabPosition: "byWeek",
      disabled: [false, true],
      flod: false,
      limitNum: "1"
    };
  },
  created() {
    this.limitNum = this.page.chartNum;
    if (this.headerVal !== undefined && Object.keys(this.headerVal).length) {
      this.changeHeader(this.headerVal.time);
    }
  },
  computed: {
    // 公共数据
    queryCommon() {
      return this.$store.state.query_common;
    },
    queryIndex() {
      let tableData = {};
      tableData = Object.assign(
        {},
        tableData,
        this.$store.state.query_common,
        this.$store.state.query_table
      );
      return this.getIndex(tableData);
    },
    queryTable() {
      const self = this;
      let chart = {};
      chart = Object.assign(
        {},
        chart,
        self.$store.state.query_data,
        self.$store.state.query_common,
        { byWhichWay: this.tabPosition }
      );
      return self.getTable(chart);
    }
  },
  watch: {
    queryIndex(now, o) {},
    queryTable(now, o) {},
    queryCommon(now, o) {},
    "headerVal.time": {
      deep: true, // 深度监听设置为 true
      handler: function(newV) {
        this.changeHeader(newV);
      }
    }
  },
  methods: {
    // 查询表格和重要指标
    getIndex(params) {
      if (
        this.$route.name === this.page.name &&
        Object.keys(params).indexOf("indicatorIDs") >= 0
      ) {
        queryUtil.changeParams(
          this.headerShow,
          params,
          this.page.tableTitle,
          this.header.contrast
        );
        queryUtil.changeIndexParams(params);
        if (this.$route.name === "cust_save") {
          params.indicatorID = 180;
        }
        if (
          this.$route.name === "activity_save" ||
          this.$route.name === "coupons_save"
        ) {
          params.indicatorID = 191;
          {
            if (params.discountID === undefined) return;
          }
        }
        Func.getIndexTwo(this, params);
      } else {
        return {};
      }
    },
    getTable(params) {
      // 正常的有关键指标，也有图表
      if (
        this.$route.name === this.page.name &&
        Object.keys(params).indexOf("indicatorIDs") >= 0
      ) {
        queryUtil.changeParams(
          this.headerShow,
          params,
          this.page.tableTitle,
          this.header.contrast
        );
        if (this.$route.name === "cust_save") {
          params.indicatorID = 180;
        }
        if (this.page.xname === "consume" || this.page.xname === "expense") {
          params.type = 1;
        }
        if (
          this.$route.name === "activity_save" ||
          this.$route.name === "coupons_save"
        ) {
          params.indicatorID = 191;
          {
            if (params.discountID === undefined) return;
          }
        }
        Func.getRetainTable(this, params);
      } else {
        return {};
      }
    },
    // 表头时间改变，改变按日，按周，按月的选择禁用
    changeHeader(val) {
      let timeBlock = util.report.timeinterval(val);
      this.disabled = [true, true];
      // 按周
      if (timeBlock >= 8 && timeBlock < 32) {
        this.disabled = [false, true];
        this.tabPosition = "byWeek";
      } else if (timeBlock >= 32) {
        // 按月
        this.disabled = [false, false];
      }
    }
  }
};
</script>

<style lang="less">
</style>
